export default __webpack_public_path__ + "static/bgRight-6161f701ff92ea8339d48548d2aaeb59.png";